
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analyzer",
      function () {
        return require("private-next-pages/analyzer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analyzer"])
      });
    }
  